import { ButtonMain } from '@quero-delivery/quero-components-web';
import { useParams } from 'react-router-dom';
import { Modal } from '@querodelivery/uni-react';
import PurpleButton from '@/Components/shared/purple-button/PurpleButton';
import styles from './confirm-modal-block.module.scss';
import type { ConfirmModalBlockProps } from './types';
import { usePlaces as useGetPlaces } from '@/_hooks/use-places';

import useMotoboy from '@/hooks/motoboy/useMotoboy';
import { MODAL_WIDTH } from '@/_constants/styles';

function ConfirmModalBlock(props: ConfirmModalBlockProps) {
  const { open, onClose, onConfirm, title, params, paramsToDelete, isLoading } =
    props;

  const { motoboyId } = useParams<{ motoboyId: string }>();

  const { motoboy } = useMotoboy(motoboyId || '');

  const { placesOptionsWithAll } = useGetPlaces({
    cityId: motoboy?.municipioId,
  });

  const selectedOption = placesOptionsWithAll?.find(
    option => option.value === params?.placeId,
  );

  const isBlockedTemporary =
    params?.blockType === 'TEMPORARY' ||
    paramsToDelete?.blockType === 'TEMPORARY';

  const placeName = paramsToDelete
    ? paramsToDelete?.placeName ||
      (paramsToDelete.isBlockedBySystem
        ? 'Bloqueio automático do sistema'
        : 'Todos')
    : selectedOption?.text;

  const timeBlockedText = paramsToDelete
    ? paramsToDelete?.period
    : params?.periodType
    ? params?.period[params?.periodType]
    : '';

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      header={title}
      width={MODAL_WIDTH.md}
    >
      <div>
        <div className={styles.textContainer}>
          <div>
            <span>Estabelecimento(s)</span>
            <span>Motivo da suspensão</span>
            <span>Tipo de bloqueio</span>
            {isBlockedTemporary && (
              <>
                <span>Período de bloqueio</span>
                <span>Tempo de bloqueio</span>
              </>
            )}
          </div>
          <div>
            <span>{placeName}</span>
            <span>
              {paramsToDelete
                ? paramsToDelete?.blockReason
                : params?.reasonToBlock}
            </span>
            <span>
              {paramsToDelete ? paramsToDelete.blockType : params?.blockType}
            </span>
            {isBlockedTemporary && (
              <>
                <span>
                  {paramsToDelete
                    ? paramsToDelete?.periodType
                    : params?.periodType}
                </span>
                <span>{timeBlockedText}</span>
              </>
            )}
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <ButtonMain secondary width="35%" textFirst="Não" onClick={onClose} />
          <PurpleButton
            width="35%"
            textFirst="Sim"
            onClick={onConfirm}
            loading={isLoading}
            disabled={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}

export { ConfirmModalBlock };
